import React, { useEffect } from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
const MobileAdhesion = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const { advertIsOff  } = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['MobileAdhesion'], safety, {
        refreshLimit: 30,
        refreshTime: 30,
        format: 'anchor',
        anchor: 'bottom',
        anchorPersistClose: false,
        report: {
            enabled: false
        },
        mediaQuery: '(min-width: 768px) and (max-width: 1024px), (min-width: 320px) and (max-width: 767px)'
    });
    useEffect(()=>{
        if (advertIsOff) {
            var _slot_parentElement;
            const slot = document.getElementById(ADUNIT_MAP['MobileAdhesion']);
            slot === null || slot === void 0 ? void 0 : (_slot_parentElement = slot.parentElement) === null || _slot_parentElement === void 0 ? void 0 : _slot_parentElement.removeChild(slot);
        }
    }, [
        advertIsOff
    ]);
    return null; // anchors DONT need a div
}, adunitMemo);
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
